import Table from 'react-bootstrap/Table';
import toast from 'react-hot-toast';

import { GO } from '@/types';
// import { MODAL_TYPES as MDT } from '@/types/options';

import { useUpdateUser, useConfirmEmail } from '@/features/users';

import { User, USER_STATUS } from '../types';

const getDay = (createdAt: string) => createdAt.split('T')[0];
const userStyleChanged = (user: User): string => {
  return user.status == 'CANCELED' ? 'text-decoration-line-through' : '';
};
const isUserAlive = (user: User) => user.status == USER_STATUS.A;
const isUserFrozen = (user: User) => user.status == USER_STATUS.D;
const isUserConfirmed = (user: User) => user.email_confirmed == 1;

/**
 * Created at 2024/09/24
 */
export const UserManageTable = ({
  orderedUser,
}: {
  orderedUser: User[];
  // openBy: (type: string, context?: GO) => void;
}) => {
  const updateUserMutation = useUpdateUser({});
  const confirmUserMutaion = useConfirmEmail({});

  const disableUser = async (userId: string) => {
    await updateUserMutation.mutateAsync({
      id: userId,
      data: { status: 'CANCELED' },
    });
  };

  const enableUser = async (userId: string) => {
    await updateUserMutation.mutateAsync({
      id: userId,
      data: { status: 'ACTIVE' },
    });
  };

  const confirmUser = async (email: string) => {
    await confirmUserMutaion.mutateAsync({
      email,
    });
  };

  return (
    <Table striped bordered hover>
      <thead>
        <tr>
          <th>ID</th>
          <th>Username</th>
          <th>Email</th>
          <th>Company</th>
          <th>Role</th>
          <th>Created At</th>
          <th>Operation</th>
        </tr>
      </thead>
      <tbody>
        {orderedUser.length == 0 && <p>loading users...</p>}
        {orderedUser.map((usr) => (
          <tr key={usr.id}>
            <td className={userStyleChanged(usr)}>{usr.id}</td>
            <td className={userStyleChanged(usr)}>{usr.name}</td>
            <td className={userStyleChanged(usr)}>{usr.email}</td>
            <td>?</td>
            <td>?</td>
            <td>{getDay(`${usr.date_created}`)}</td>
            <td>
              {isUserFrozen(usr) && (
                <button
                  type="button"
                  className="btn btn-outline-success btn-sm me-2"
                  onClick={() => {
                    enableUser(`${usr.id}`);
                  }}
                >
                  Enable
                </button>
              )}
              {/* == disable the user == */}
              {isUserAlive(usr) && (
                <button
                  type="button"
                  className="btn btn-outline-warning btn-sm me-2"
                  onClick={() => {
                    disableUser(`${usr.id}`);
                  }}
                >
                  Disable
                </button>
              )}
              {/* === manual confirmed == */}
              {!isUserConfirmed(usr) && (
                <button
                  type="button"
                  className="btn btn-outline-info btn-sm me-2"
                  onClick={() => {
                    confirmUser(`${usr.email}`);
                  }}
                >
                  Confirm
                </button>
              )}
              {/* == permanently delete the user == */}
              {/* <button
                type="button"
                className="btn btn-outline-danger btn-sm"
                onClick={() =>
                  openBy(MDT.DELETE_USER, {
                    userId: usr.id,
                    userName: usr.name,
                  })
                }
              >
                Delete
              </button> */}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};
